import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';

import { getFragmentData } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { ActorAvatar } from './ActorAvatar';
import { FolderBusinessEntityListCmp_ThirdParty_Fragment } from './fragments/third-party.fragment';
import { useActorCategoriesLabel } from './hooks/useActorCategoriesLabel.hook';
import { getThirdPartyName } from './utils/third-party-name.util';

// Where the avatar sits along a name on several lines: centered by default, against the item
// below (end) or above (start) when an arrow links them.
type AvatarAlignment = 'center' | 'end' | 'start';

const ALIGN_ITEMS: Readonly<Record<AvatarAlignment, string>> = {
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
};

interface Props {
  readonly avatarAlignment?: AvatarAlignment;
  readonly actor: Readonly<{
    categoryIds: readonly string[];
    thirdParty: FragmentType<
      typeof FolderBusinessEntityListCmp_ThirdParty_Fragment
    >;
  }>;
}

export const ActorListItem = ({
  actor,
  avatarAlignment = 'center',
}: Readonly<Props>) => {
  const getCategoriesLabel = useActorCategoriesLabel();

  const thirdParty = getFragmentData(
    FolderBusinessEntityListCmp_ThirdParty_Fragment,
    actor.thirdParty,
  );
  const categoriesLabel = getCategoriesLabel(actor.categoryIds);

  return (
    <ListItem sx={{ alignItems: ALIGN_ITEMS[avatarAlignment] }}>
      <ListItemAvatar sx={{ mt: 0 }}>
        <ActorAvatar
          categoriesLabel={categoriesLabel}
          showTooltip={false}
          thirdParty={thirdParty}
        />
      </ListItemAvatar>
      <ListItemText
        primary={getThirdPartyName(thirdParty)}
        secondary={categoriesLabel}
      />
    </ListItem>
  );
};
